import { NgModule } from '@angular/core';
import { QrCodeComponent } from './qr-code.component';



@NgModule({
  declarations: [QrCodeComponent],
  exports: [QrCodeComponent],
})
export class QriousModule { }
